import { path } from 'ramda';

export const getLoginInformation = path(['authentication', 'loginInformations']);
export const getSessionInformation = path(['authentication', 'sessionInformation']);
export const getRefusal = path(['authentication', 'refusal']);
export const getAttemptError = path(['authentication', 'attemptError']);
export const getSession = path(['authentication', 'session']);
export const getSsoReady = path(['authentication', 'ssoReady']);
